<template>
    <section class="services">
        <div class="section-title">
            <h2>خدمات رامنیک</h2>
            <p>راهنمای نحوه دریافت خدمات رامنیک</p>
        </div>
        <div class="row">
            <div class="col-md-6 mt-4" v-for="(service,index) in services" :key="index">
                <div class="icon-box bg-light">
                    <h4>{{ service.name }}</h4>
                    <p v-html="service.caption"></p>
                    <div class="col-12 text-left">
                        <router-link :to="{
                  name: 'content',
                  params: { slug: service.slug.replace(' ', '-') }
                }">مشاهده بیشتر</router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mt-5">
                <router-link class="link-more text-dark" :to="{ name: 'services' }">مشاهده همه خدمات</router-link>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            rootImagePath: {
                type: String
            },

            services: {
                type: Array
            }
        }
    };
</script>
<style scoped>
    .services .icon-box {
        padding: 30px;
        border-radius: 10px;
        background: #fff;
        transition: ease-in-out 0.3s;
    }

        .services .icon-box i {
            float: left;
            color: #3498db;
            font-size: 40px;
        }

        .services .icon-box h4 {
            margin-left: 70px;
            font-weight: 700;
            margin-bottom: 15px;
            font-size: 18px;
        }

            .services .icon-box h4 a {
                color: #384046;
                transition: 0.3s;
            }

        .services .icon-box p {
            margin-left: 70px;
            line-height: 24px;
            font-size: 14px;
        }

        .services .icon-box:hover {
            box-shadow: 0px 2px 22px rgba(0, 0, 0, 0.08);
        }

            .services .icon-box:hover h4 a {
                color: #3498db;
            }
</style>
